// extracted by mini-css-extract-plugin
export default {"button":"All_button__97tKg","wrapper":"All_wrapper__S+DYa","a":"All_a__ZOGAY"};